import type { DependencyList } from 'react';
import { useEffect } from 'react';
import { useTimeout } from './useTimeout';

/**
 * Calls `callback` `delay` ms after `dependencies` last changed. Not on mount: the timer
 * the mount starts is cleared straight away, so only a change after mount fires it.
 */
export const useDebounce = (callback: () => void, delay: number, dependencies: DependencyList) => {
  const { reset, clear } = useTimeout(callback, delay);
  useEffect(reset, [...dependencies, delay]);
  useEffect(clear, []);
};
